import React from 'react'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'

class TiposSSL extends React.Component {


    shouldComponentUpdate() {
        return false
    }


    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;            
            background-size: cover;
            padding: 30px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 1100px 0 50px 0;
            }
                @media (min-width:768px) and (max-width:1400px) {
                padding: 200px 0 50px 0;              
            }            
          }
        `

        const ServiceContainer = styled.div`
            background-color: rgba(0,0,0,.9);            
        `

        const Text = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #ffffff;
            padding-bottom: 30px;
            text-align: center;          
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #c1eb18;            
        `
        const ColorV = styled.span`            
            color: #c1eb18;
            font-family: Teko;                        
        `
        const Heading2 = styled.h2`
            transform: translate(0px, -100px);
            transition: 1s;
            margin-top: 100px;
            font-size: 95px;
            line-height: 110px;
            font-family: Teko;
            font-weight: 500;
            color: rgb(255, 255, 255);
            text-align: center;
            text-transform: uppercase;
            @media (max-width: 767px) {                
                font-size: 70px;
                line-height: 80px;                
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 20px 0 0 0;              
            }          
        `
        const Heading3 = styled.h3`
            font-size: 40px;
            font-family: Poppins;
            font-weight: 700;
            color: #48565e;
            line-height: 50px;
            text-align: center;
            padding: 80px 0;        
        `
        const TextaSpan = styled.a`        
            color: #78c91c;
            transition: .5s;
            cursor: pointer;
            scroll-behavior: smooth;            
            &:hover {
                color: #fff;
                text-decoration: none;
            }
        `
        
        const handleScrollToCA = (e) => {
            e.preventDefault();
            const target = document.getElementById('CA');
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        return (
            <Section>
                <ServiceContainer>
                    <Container>
                        <Heading2>Tipos de Certificados SSL: <ColorV>Encuentra el Ideal</ColorV></Heading2>
                        <Text>
                            Asegura sitios web, aplicaciones, extranets y plataformas en Bogotá, Medellín, Barranquilla, Pereira, Cali, Bucaramanga, Cartagena y más.
                            No necesitas acreditación ONAC, disfruta de un reembolso de 30 días, y elige entre DigiCert, Sectigo, GeoTrust, o soluciones multidominio (SAN).
                            ¡Obtén SSL gratis con hosting!
                        </Text>
                        <Text>
                            Los <Color>Certificados Digitales SSL</Color> son pequeños archivos de datos que se instalan en un servidor web, para establecer una
                            conexión segura cifrada <Color>(https)</Color> entre el navegador del usuario y el servidor.
                        </Text>
                        <Text>
                            Cuando un usuario visita un sitio web protegido con un certificado SSL, el protocolo <Color>SSL/TLS (Transport Layer Security)</Color> crea
                            una conexión segura cifrada entre el navegador del usuario y el servidor web, lo que garantiza que la información confidencial, como
                            contraseñas, datos de tarjetas de crédito y otra información personal, esté protegida contra posibles ataques de terceros.
                        </Text>
                        <Text>
                            Los certificados SSL protegen la información sensible de tus usuarios, mejoran el SEO y generan confianza. Desde Bogotá hasta Bucaramanga,
                            ofrecemos soluciones para sitios, apps y plataformas con soporte local y precios realmente económicos.
                        </Text>
                        <Heading3>
                            <TextaSpan a href="#CA" onClick={handleScrollToCA}>Descubre los Certificados SSL Disponibles</TextaSpan>
                        </Heading3>
                    </Container>
                </ServiceContainer>
            </Section>
        )
    }

}

export default TiposSSL;